export const themeColors = {
	primary: '#110BE0', // main Ultramarine blue
	secondary: '#110BE0', // main Ultramarine blue

	err: '#FF4856',

	neutral: '#474346',
	darkNeutral: '#877D85',
	midNeutral: '#CBCAC6',
	lightNeutral: '#F5F5F5',

	text: '',

	black: '',
	white: '#FFFFFF',

	expert: '#132F5C',
	advanced: '#EE4B22',
	intermediate: '#EC9706',
	beginner: '#4D929F',

	// OLD COLORS

	ctaBorder: '',

	offWhite: '#F5F5F5',

	grey: '#808080',
	lightGrey: '#cccccc',
	paleGrey: '#F5F5F5',
	blueGrey: '#D3D3FF',
	darkGrey: '#1e1e1e',

	lightPink: '#ffd3e5',
	tan: '#e9bc95',
	lightTan: '#fbd4af',
	cream: '#fff1e4',
	darkBrown: '#333333',
	lavender: '#BFBFFF',
	teal: '#A2FBD0',
}

themeColors.ctaBorder = themeColors.secondary
themeColors.text = themeColors.neutral
themeColors.black = themeColors.neutral

export type ThemeColor = keyof typeof themeColors
